module.exports = __webpack_public_path__ + "static/mentor-apoorv-049e67905eb948a239bd77041c322489.png";